import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      app_name: "INCEPTION Sports Hub",
      dashboard: "Dashboard",
      sponsors: "Sponsors",
      rights: "Rights",
      matches: "Matches",
      clubs: "Clubs",
      stadiums: "Stadiums",
      stadiums_desc: "Manage match venues",
      add_stadium: "Add Stadium",
      edit_stadium: "Edit Stadium",
      sync_from_matches: "Sync from Matches",
      no_stadiums_yet: "No stadiums yet. Add one or sync from matches.",
      select_stadium: "Select stadium",
      roles_permissions: "Roles & Permissions",
      roles_desc: "Manage user roles and their platform permissions",
      create_role: "Create Role",
      edit_role: "Edit Role",
      role_name: "Role Name",
      permissions: "Permissions",
      requests: "Requests",
      reports: "Reports",
      audit_log: "Audit Log",
      notifications: "Notifications",
      logout: "Logout",
      sign_in: "Sign In",
      email: "Email",
      password: "Password",
      enter_credentials: "Enter your credentials to access the portal",
      demo_accounts: "Demo Accounts",
      admin: "Admin",
      account_manager: "Account Manager",
      sponsor: "Sponsor",
      active_sponsors: "Active Sponsors",
      active_rights: "Active Rights",
      upcoming_matches: "Upcoming Matches",
      total_requests: "Total Requests",
      pending_requests: "Pending Requests",
      approved_requests: "Approved Requests",
      recent_requests: "Recent Requests",
      my_dashboard: "My Dashboard",
      my_rights_balances: "My Rights & Balances",
      new_request: "New Request",
      create_request: "Create Request",
      match_details: "Match Details",
      requests_for_match: "Requests for this match",
      allocation: "Allocation",
      used: "Used",
      remaining: "Remaining",
      pending: "Pending",
      available_to_request: "Available to request",
      per_match_max: "Per match max",
      unlimited: "Unlimited",
      limited: "Limited",
      submitted: "Submitted",
      under_review: "Under Review",
      approved: "Approved",
      partially_approved: "Partially Approved",
      rejected: "Rejected",
      cancelled: "Cancelled",
      status: "Status",
      date: "Date",
      actions: "Actions",
      view: "View",
      edit: "Edit",
      create: "Create",
      save: "Save",
      cancel: "Cancel",
      search: "Search",
      company_name: "Company Name",
      contact_name: "Contact Name",
      mobile: "Mobile",
      notes: "Notes",
      admin_dashboard: "Admin Dashboard",
      system_overview: "System overview and recent activity",
      my_sponsors: "My Sponsors",
      sport_portal: "Sports Hub",
      match: "Match",
      competition: "Competition",
      venue: "Venue",
      items: "Items",
      add_match: "Add Match",
      import_schedule: "Import",
      home_team: "Home Team",
      away_team: "Away Team",
      round: "Round",
      match_date: "Match Date",
      kickoff_time: "Kickoff Time",
      stadium: "Stadium",
      city: "City",
      add_sponsor: "Add Sponsor",
      create_right: "Create Right",
      assign_right: "Assign Right",
      right_name: "Right Name",
      description: "Description",
      unit_type: "Unit Type",
      allocation_type: "Allocation Type",
      allocated_amount: "Allocated Amount",
      used_amount: "Used Amount",
      remaining_amount: "Remaining Amount",
      per_match_limit: "Per Match Limit",
      request_items: "Request Items",
      requested: "Requested",
      approved_qty: "Approved Qty",
      rejected_qty: "Rejected Qty",
      reviewer_note: "Reviewer Note",
      submit_review: "Submit Review",
      cancel_request: "Cancel Request",
      confirm_decision: "Confirm Decision",
      select_match: "Select a match",
      select_right: "Select right",
      quantity: "Quantity",
      submit_request: "Submit Request",
      usage_report: "Usage Report",
      sponsor_usage: "Sponsor usage and allocation overview",
      no_data: "No data available",
      loading: "Loading...",
      welcome_back: "Welcome back!",
      welcome_name: "Welcome, {{name}}",
      done: "Done",
      total_users: "Total Users",
      logo: "Logo",
      upload_logo: "Upload Logo",
      sponsor_logo: "Sponsor Logo",
      // Manager Dashboard
      manager_dashboard: "Account Manager Dashboard",
      your_activity: "Your sponsors and recent activity",
      // Sponsors Page
      sponsors_registered: "sponsors registered",
      new_sponsor: "New Sponsor",
      search_sponsors: "Search sponsors...",
      company: "Company",
      contact: "Contact",
      fill_required: "Fill required fields",
      sponsor_created: "Sponsor created! Default password: sponsor123",
      sponsor_submitted_for_approval: "Sponsor submitted for admin approval",
      sponsor_approved: "Sponsor approved",
      sponsor_rejected: "Sponsor rejected",
      no_sponsors: "No sponsors found",
      select_manager: "Select manager",
      contract_start: "Contract Start",
      contract_end: "Contract End",
      // Matches Page
      matches_in_schedule: "matches in schedule",
      new_match: "New Match",
      search_matches: "Search matches...",
      all_statuses: "All statuses",
      all_teams: "All Teams",
      upcoming: "Upcoming",
      closed: "Closed",
      completed: "Completed",
      no_matches: "No matches found",
      match_created: "Match created",
      select_team: "Select team",
      select_stadium: "Select stadium",
      select_round: "Select round",
      club_name: "Club Name",
      short_name: "Short Name",
      badge_url: "Badge URL",
      add_club: "Add Club",
      edit_club: "Edit Club",
      club_created: "Club created",
      club_updated: "Club updated",
      club_deleted: "Club deleted",
      no_clubs: "No clubs found",
      // Requests Page
      my_requests: "My Requests",
      search_requests: "Search requests...",
      no_requests: "No requests found",
      // Rights Page
      rights_management: "Rights Management",
      manage_rights: "Manage rights and assignments",
      rights_master: "Rights Master",
      assignments: "Assignments",
      search_rights: "Search rights...",
      name: "Name",
      type: "Type",
      no_rights: "No rights found",
      no_assignments: "No assignments",
      right_created: "Right created",
      per_match: "Per Match",
      allocated: "Allocated",
      // Reports Page
      // Audit Log
      entries: "entries",
      all_types: "All Types",
      action: "Action",
      user: "User",
      details: "Details",
      time: "Time",
      page_of: "Page {{page}} of {{pages}}",
      no_audit: "No audit entries",
      // Sponsor Detail
      sponsor_details: "Sponsor Details",
      info: "Info",
      back: "Back",
      save_changes: "Save Changes",
      sponsor_updated: "Sponsor updated",
      alloc: "Alloc",
      remain: "Remain",
      no_requests_found: "No requests",
      // Create Request
      select_match_step: "1. Select Match",
      choose_match: "Choose a match",
      select_rights_step: "2. Select Rights & Quantities",
      add_item: "Add Item",
      click_add: "Click \"Add Item\" to select rights",
      notes_submit: "3. Notes & Submit",
      any_notes: "Any special requests or notes...",
      submitting: "Submitting...",
      request_submitted: "Request submitted successfully!",
      select_a_match: "Select a match",
      add_one_item: "Add at least one item",
      fill_all_items: "Fill all items with valid quantities",
      right: "Right",
      avail: "Avail",
      // Request Detail
      request_details: "Request Details",
      match_info: "Match",
      sponsor_info: "Sponsor",
      requested_by: "Requested by",
      exclusive: "Exclusive",
      exclusive_desc: "Only one sponsor can book this right per match",
      password_policy: "Min 8 characters, 1 uppercase, 1 digit, 1 special character",
      balance_info: "Balance Info",
      note: "Note",
      internal_note: "Internal Note",
      internal_notes: "Internal notes...",
      reject: "Reject",
      cancel_this: "Are you sure you want to cancel this request?",
      request_reviewed: "Request reviewed successfully",
      request_cancelled: "Request cancelled",
      review_notes: "Review Notes",
      internal: "Internal",
      // Schedule Import
      import_season: "Import Season Schedule",
      upload_file: "Upload File",
      upload_desc: "Upload a CSV or Excel file with match data. Required columns: home_team, away_team, match_date",
      download_template: "Download Template",
      upload_preview: "Upload & Preview",
      parsing: "Parsing...",
      preview: "Preview",
      total: "Total",
      valid: "Valid",
      invalid: "Invalid",
      save_matches: "Save {{count}} Matches",
      saving: "Saving...",
      imported_matches: "Imported {{count}} matches",
      errors: "Errors",
      select_file: "Select a file first",
      // Charts
      requests_overview: "Requests Overview",
      system_overview_chart: "System Overview",
      rights_used_remaining: "Rights Used vs Remaining",
      requests_status: "Requests Status",
      other: "Other",
      mark_all_read: "Mark all read",
      no_notifications: "No notifications",
      // Sponsor logo
      change_logo: "Change Logo",
      remove_logo: "Remove Logo",
      right_updated: "Right updated successfully",
      right_assigned: "Right assigned successfully",
      assignment_updated: "Assignment updated successfully",
      assignment_deleted: "Assignment deleted",
      confirm_delete_assignment: "Are you sure you want to delete this assignment?",
      select_sponsor: "Select sponsor",
      active: "Active",
      inactive: "Inactive",
      assignment: "Assignment",
      minimum: "Minimum",
      profile: "Profile",
      manage_profile: "Manage your account settings",
      profile_updated: "Profile updated successfully",
      password_changed: "Password changed successfully",
      passwords_mismatch: "Passwords do not match",
      password_too_short: "Password must be at least 6 characters",
      change_password: "Change Password",
      current_password: "Current Password",
      new_password: "New Password",
      confirm_password: "Confirm Password",
      mobile: "Mobile",
      pdf_exported: "PDF exported successfully",
      users_management: "Users",
      users: "Users",
      user: "User",
      invite_user: "Invite User",
      send_invite_email: "Send invitation email",
      dark_mode: "Dark Mode",
      light_mode: "Light Mode",
      customize: "Customize",
      show_hide: "Show/Hide widgets",
      statistics: "Statistics",
      forgot_password: "Forgot Password",
      forgot_password_desc: "Enter your email to receive a new password",
      send_reset: "Send Reset Email",
      check_email: "Check your email",
      back_to_login: "Back to Login",
      avatar_updated: "Avatar updated",
      usage_chart: "Usage Overview",
      export: "Export",
      edit_match: "Edit Match",
      match_updated: "Match updated successfully",
      match_deleted: "Match deleted successfully",
      confirm_delete_match: "Are you sure you want to delete this match?",
      delete: "Delete",
      upcoming_round: "Upcoming Round",
      request_deadline: "Request Deadline",
      role: "Role",
      cancellation_requested: "Cancellation Requested",
      confirm_cancel_approved: "This request is already approved. A cancellation request will be sent to the account manager for approval. Continue?",
      confirm_approve_cancellation: "Are you sure you want to approve this cancellation? The sponsor's rights balance will be restored.",
      confirm_reject_cancellation: "Are you sure you want to reject this cancellation request? The request will remain approved.",
      approve_cancellation: "Approve Cancellation",
      reject_cancellation: "Reject Cancellation",
      cancellation_approved: "Cancellation approved",
      cancellation_rejected: "Cancellation rejected",
      cancellation_pending_msg: "Sponsor has requested cancellation of this approved request",
      cancellation_awaiting_approval: "Your cancellation request is pending manager approval",
      adjust_allocation: "Adjust Allocation",
      current_allocation: "Current",
      adjustment_amount: "Adjustment Amount",
      adjustment_hint: "Positive to increase, negative to decrease",
      reason: "Reason",
      adjustment_reason_placeholder: "Reason for adjustment...",
      apply_adjustment: "Apply Adjustment",
      allocation_adjusted: "Allocation adjusted successfully",
      enter_valid_adjustment: "Enter a valid non-zero number",
      reason_required: "Reason is required",
      change_history: "Change History",
      admin_settings: "Admin Settings",
      admin_settings_desc: "Configure system-wide settings",
      general: "General",
      session_settings: "Session Settings",
      session_timeout: "Session Timeout",
      session_timeout_desc: "Automatically log out users after a period of inactivity",
      minutes: "min",
      save_settings: "Save Settings",
      settings_saved: "Settings saved",
      settings: "Settings",
      spo_viewer: "SPO Viewer",
      select_sponsor: "Select sponsor",
      choose_sponsor: "Choose sponsor",
      confirm_delivery: "Confirm Delivery",
      confirm_delivery_msg: "Confirm that this request has been delivered? Cancellation will no longer be possible.",
      delivery_confirmed: "Delivery confirmed successfully",
      delivered_confirmed_label: "Delivered",
      delivery_note_placeholder: "Add delivery notes (optional)...",
      mark_as_delivered: "Mark as Delivered",
      pending_your_approval: "This request was created on your behalf. Please review and approve.",
      add_notes_before_approval: "Add your notes before approving...",
      approve_and_submit: "Approve & Submit",
      reject_request: "Reject",
      confirm_sponsor_approve: "Approve this request and submit it for review?",
      confirm_sponsor_reject: "Reject this request? It will be closed.",
      request_approved_by_sponsor: "Request approved and submitted",
      request_rejected_by_sponsor: "Request rejected",
      request_created_on_behalf: "Request created on behalf of sponsor",
      pending_sponsor_approval: "Pending Sponsor Approval",
      sponsor_reports: "Sponsor Reports",
      sponsor_reports_desc: "View reports shared by your account manager",
      usage_reports: "Usage Reports",
      reports_desc: "Manage sponsor reports and view usage",
      create_report: "Create Report",
      round_number: "Round Number",
      report_link: "Report Link",
      report_title_placeholder: "e.g. Round 15 Summary Report",
      view_report: "View Report",
      report_created: "Report created",
      no_reports: "No reports available",
      session_expired: "Session expired. Please log in again.",
      create_on_behalf: "Create On Behalf",
      sync_spl: "Sync SPL",
      syncing: "Syncing...",
      matches_imported: "matches imported",
      skipped: "already existed",
      synced: "Synced",
      approve_all: "Approve All",
      reject_all: "Reject All",
      confirm_approve_all: "Approve All Requests",
      confirm_reject_all: "Reject All Requests",
      approve_all_disclaimer: "All pending requests will be approved with their full requested quantities. This action cannot be undone.",
      reject_all_disclaimer: "All pending requests will be rejected. This action cannot be undone.",
      send_decision: "Send Decision",
      decision_sent: "Decision sent successfully",
      all_items_approved: "All items set to approved",
      translations_label: "Translations",
      just_now: "Just now",
    }
  },
  ar: {
    translation: {
      app_name: "بوابة إنسبشن الرياضية",
      dashboard: "لوحة القيادة",
      sponsors: "الرعاة",
      rights: "الحقوق",
      matches: "المباريات",
      clubs: "الأندية",
      stadiums: "الملاعب",
      stadiums_desc: "إدارة ملاعب المباريات",
      add_stadium: "إضافة ملعب",
      edit_stadium: "تعديل ملعب",
      sync_from_matches: "مزامنة من المباريات",
      no_stadiums_yet: "لا توجد ملاعب بعد. أضف واحداً أو زامن من المباريات.",
      select_stadium: "اختر الملعب",
      roles_permissions: "الأدوار والصلاحيات",
      roles_desc: "إدارة أدوار المستخدمين وصلاحياتهم",
      create_role: "إنشاء دور",
      edit_role: "تعديل الدور",
      role_name: "اسم الدور",
      permissions: "الصلاحيات",
      requests: "الطلبات",
      reports: "التقارير",
      audit_log: "سجل المراجعة",
      notifications: "الإشعارات",
      logout: "تسجيل الخروج",
      sign_in: "تسجيل الدخول",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      enter_credentials: "أدخل بيانات الاعتماد للوصول إلى البوابة",
      demo_accounts: "حسابات تجريبية",
      admin: "مدير النظام",
      account_manager: "مدير الحسابات",
      sponsor: "الراعي",
      active_sponsors: "الرعاة النشطون",
      active_rights: "الحقوق النشطة",
      upcoming_matches: "المباريات القادمة",
      total_requests: "إجمالي الطلبات",
      pending_requests: "الطلبات المعلقة",
      approved_requests: "الطلبات المعتمدة",
      recent_requests: "أحدث الطلبات",
      my_dashboard: "لوحة القيادة",
      my_rights_balances: "حقوقي وأرصدتي",
      new_request: "طلب جديد",
      create_request: "إنشاء طلب",
      match_details: "تفاصيل المباراة",
      requests_for_match: "الطلبات لهذه المباراة",
      allocation: "التخصيص",
      used: "المستخدم",
      remaining: "المتبقي",
      pending: "معلق",
      available_to_request: "متاح للطلب",
      per_match_max: "الحد الأقصى لكل مباراة",
      unlimited: "غير محدود",
      limited: "محدود",
      submitted: "مقدم",
      under_review: "قيد المراجعة",
      approved: "معتمد",
      partially_approved: "معتمد جزئياً",
      rejected: "مرفوض",
      cancelled: "ملغي",
      status: "الحالة",
      date: "التاريخ",
      actions: "الإجراءات",
      view: "عرض",
      edit: "تعديل",
      create: "إنشاء",
      save: "حفظ",
      cancel: "إلغاء",
      search: "بحث",
      company_name: "اسم الشركة",
      contact_name: "اسم جهة الاتصال",
      mobile: "الهاتف",
      notes: "ملاحظات",
      admin_dashboard: "لوحة قيادة المدير",
      system_overview: "نظرة عامة على النظام والنشاط الأخير",
      my_sponsors: "رعاتي",
      sport_portal: "البوابة الرياضية",
      match: "المباراة",
      competition: "المسابقة",
      venue: "المكان",
      items: "العناصر",
      add_match: "إضافة مباراة",
      import_schedule: "استيراد",
      home_team: "الفريق المضيف",
      away_team: "الفريق الضيف",
      round: "الجولة",
      match_date: "تاريخ المباراة",
      kickoff_time: "وقت الانطلاق",
      stadium: "الملعب",
      city: "المدينة",
      add_sponsor: "إضافة راعي",
      create_right: "إنشاء حق",
      assign_right: "تعيين حق",
      right_name: "اسم الحق",
      description: "الوصف",
      unit_type: "نوع الوحدة",
      allocation_type: "نوع التخصيص",
      allocated_amount: "المبلغ المخصص",
      used_amount: "المبلغ المستخدم",
      remaining_amount: "المبلغ المتبقي",
      per_match_limit: "الحد لكل مباراة",
      request_items: "عناصر الطلب",
      requested: "المطلوب",
      approved_qty: "الكمية المعتمدة",
      rejected_qty: "الكمية المرفوضة",
      reviewer_note: "ملاحظة المراجع",
      submit_review: "تقديم المراجعة",
      cancel_request: "إلغاء الطلب",
      confirm_decision: "تأكيد القرار",
      select_match: "اختر مباراة",
      select_right: "اختر حق",
      quantity: "الكمية",
      submit_request: "تقديم الطلب",
      usage_report: "تقرير الاستخدام",
      sponsor_usage: "نظرة عامة على استخدام وتخصيص الرعاة",
      no_data: "لا توجد بيانات متاحة",
      loading: "جاري التحميل...",
      welcome_back: "!مرحباً بعودتك",
      welcome_name: "مرحباً، {{name}}",
      done: "تم",
      total_users: "إجمالي المستخدمين",
      logo: "الشعار",
      upload_logo: "تحميل الشعار",
      sponsor_logo: "شعار الراعي",
      manager_dashboard: "لوحة قيادة مدير الحسابات",
      your_activity: "الرعاة والنشاط الأخير",
      sponsors_registered: "راعي مسجل",
      new_sponsor: "راعي جديد",
      search_sponsors: "البحث عن الرعاة...",
      company: "الشركة",
      contact: "جهة الاتصال",
      fill_required: "أكمل الحقول المطلوبة",
      sponsor_created: "تم إنشاء الراعي! كلمة المرور الافتراضية: sponsor123",
      sponsor_submitted_for_approval: "تم تقديم الراعي للموافقة من المسؤول",
      sponsor_approved: "تمت الموافقة على الراعي",
      sponsor_rejected: "تم رفض الراعي",
      no_sponsors: "لا يوجد رعاة",
      select_manager: "اختر مديراً",
      contract_start: "بداية العقد",
      contract_end: "نهاية العقد",
      matches_in_schedule: "مباراة في الجدول",
      new_match: "مباراة جديدة",
      search_matches: "البحث عن المباريات...",
      all_statuses: "جميع الحالات",
      all_teams: "جميع الفرق",
      upcoming: "قادمة",
      closed: "مغلقة",
      completed: "مكتملة",
      no_matches: "لا توجد مباريات",
      match_created: "تم إنشاء المباراة",
      select_team: "اختر الفريق",
      select_stadium: "اختر الملعب",
      select_round: "اختر الجولة",
      club_name: "اسم النادي",
      short_name: "الاسم المختصر",
      badge_url: "رابط الشعار",
      add_club: "إضافة نادي",
      edit_club: "تعديل النادي",
      club_created: "تم إنشاء النادي",
      club_updated: "تم تحديث النادي",
      club_deleted: "تم حذف النادي",
      no_clubs: "لا توجد أندية",
      my_requests: "طلباتي",
      search_requests: "البحث عن الطلبات...",
      no_requests: "لا توجد طلبات",
      rights_management: "إدارة الحقوق",
      manage_rights: "إدارة الحقوق والتعيينات",
      rights_master: "قائمة الحقوق",
      assignments: "التعيينات",
      search_rights: "البحث عن الحقوق...",
      name: "الاسم",
      type: "النوع",
      no_rights: "لا توجد حقوق",
      no_assignments: "لا توجد تعيينات",
      right_created: "تم إنشاء الحق",
      per_match: "لكل مباراة",
      allocated: "مخصص",
      entries: "إدخال",
      all_types: "جميع الأنواع",
      action: "الإجراء",
      user: "المستخدم",
      details: "التفاصيل",
      time: "الوقت",
      page_of: "صفحة {{page}} من {{pages}}",
      no_audit: "لا توجد سجلات",
      sponsor_details: "تفاصيل الراعي",
      info: "المعلومات",
      back: "رجوع",
      save_changes: "حفظ التغييرات",
      sponsor_updated: "تم تحديث الراعي",
      alloc: "مخصص",
      remain: "متبقي",
      no_requests_found: "لا توجد طلبات",
      select_match_step: "١. اختر المباراة",
      choose_match: "اختر مباراة",
      select_rights_step: "٢. اختر الحقوق والكميات",
      add_item: "إضافة عنصر",
      click_add: "انقر \"إضافة عنصر\" لاختيار الحقوق",
      notes_submit: "٣. ملاحظات وتقديم",
      any_notes: "أي طلبات خاصة أو ملاحظات...",
      submitting: "جاري التقديم...",
      request_submitted: "تم تقديم الطلب بنجاح!",
      select_a_match: "اختر مباراة",
      add_one_item: "أضف عنصراً واحداً على الأقل",
      fill_all_items: "أكمل جميع العناصر بكميات صحيحة",
      right: "الحق",
      avail: "متاح",
      request_details: "تفاصيل الطلب",
      match_info: "المباراة",
      sponsor_info: "الراعي",
      requested_by: "طلب بواسطة",
      exclusive: "حصري",
      exclusive_desc: "راعي واحد فقط يمكنه حجز هذا الحق لكل مباراة",
      password_policy: "8 أحرف على الأقل، حرف كبير، رقم، حرف خاص",
      balance_info: "معلومات الرصيد",
      note: "ملاحظة",
      internal_note: "ملاحظة داخلية",
      internal_notes: "ملاحظات داخلية...",
      reject: "رفض",
      cancel_this: "هل أنت متأكد من إلغاء هذا الطلب؟",
      request_reviewed: "تمت مراجعة الطلب بنجاح",
      request_cancelled: "تم إلغاء الطلب",
      review_notes: "ملاحظات المراجعة",
      internal: "داخلي",
      import_season: "استيراد جدول الموسم",
      upload_file: "تحميل ملف",
      upload_desc: "قم بتحميل ملف CSV أو Excel يحتوي على بيانات المباريات. الأعمدة المطلوبة: home_team, away_team, match_date",
      download_template: "تحميل القالب",
      upload_preview: "تحميل ومعاينة",
      parsing: "جاري التحليل...",
      preview: "معاينة",
      total: "الإجمالي",
      valid: "صالح",
      invalid: "غير صالح",
      save_matches: "حفظ {{count}} مباراة",
      saving: "جاري الحفظ...",
      imported_matches: "تم استيراد {{count}} مباراة",
      errors: "أخطاء",
      select_file: "اختر ملفاً أولاً",
      requests_overview: "نظرة عامة على الطلبات",
      system_overview_chart: "نظرة عامة على النظام",
      rights_used_remaining: "الحقوق المستخدمة مقابل المتبقية",
      requests_status: "حالة الطلبات",
      other: "أخرى",
      mark_all_read: "تحديد الكل كمقروء",
      no_notifications: "لا توجد إشعارات",
      change_logo: "تغيير الشعار",
      remove_logo: "إزالة الشعار",
      right_updated: "تم تحديث الحق بنجاح",
      right_assigned: "تم تعيين الحق بنجاح",
      assignment_updated: "تم تحديث التعيين بنجاح",
      assignment_deleted: "تم حذف التعيين",
      confirm_delete_assignment: "هل أنت متأكد من حذف هذا التعيين؟",
      select_sponsor: "اختر راعي",
      active: "نشط",
      inactive: "غير نشط",
      assignment: "تعيين",
      minimum: "الحد الأدنى",
      profile: "الملف الشخصي",
      manage_profile: "إدارة إعدادات حسابك",
      profile_updated: "تم تحديث الملف الشخصي بنجاح",
      password_changed: "تم تغيير كلمة المرور بنجاح",
      passwords_mismatch: "كلمات المرور غير متطابقة",
      password_too_short: "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
      change_password: "تغيير كلمة المرور",
      current_password: "كلمة المرور الحالية",
      new_password: "كلمة المرور الجديدة",
      confirm_password: "تأكيد كلمة المرور",
      mobile: "الجوال",
      pdf_exported: "تم تصدير PDF بنجاح",
      users_management: "المستخدمين",
      users: "المستخدمين",
      user: "مستخدم",
      invite_user: "دعوة مستخدم",
      send_invite_email: "إرسال بريد الدعوة",
      dark_mode: "الوضع الداكن",
      light_mode: "الوضع الفاتح",
      customize: "تخصيص",
      show_hide: "إظهار/إخفاء العناصر",
      statistics: "الإحصائيات",
      forgot_password: "نسيت كلمة المرور",
      forgot_password_desc: "أدخل بريدك الإلكتروني لاستلام كلمة مرور جديدة",
      send_reset: "إرسال بريد إعادة التعيين",
      check_email: "تحقق من بريدك الإلكتروني",
      back_to_login: "العودة لتسجيل الدخول",
      avatar_updated: "تم تحديث الصورة",
      usage_chart: "نظرة عامة على الاستخدام",
      export: "تصدير",
      edit_match: "تعديل المباراة",
      match_updated: "تم تحديث المباراة بنجاح",
      match_deleted: "تم حذف المباراة بنجاح",
      confirm_delete_match: "هل أنت متأكد من حذف هذه المباراة؟",
      delete: "حذف",
      upcoming_round: "الجولة القادمة",
      request_deadline: "موعد تقديم الطلبات",
      role: "الدور",
      cancellation_requested: "طلب إلغاء",
      confirm_cancel_approved: "هذا الطلب معتمد بالفعل. سيتم إرسال طلب إلغاء لمدير الحسابات للموافقة. هل تريد المتابعة؟",
      confirm_approve_cancellation: "هل أنت متأكد من الموافقة على الإلغاء؟ سيتم استعادة رصيد حقوق الراعي.",
      confirm_reject_cancellation: "هل أنت متأكد من رفض طلب الإلغاء؟ سيظل الطلب معتمداً.",
      approve_cancellation: "الموافقة على الإلغاء",
      reject_cancellation: "رفض الإلغاء",
      cancellation_approved: "تمت الموافقة على الإلغاء",
      cancellation_rejected: "تم رفض الإلغاء",
      cancellation_pending_msg: "طلب الراعي إلغاء هذا الطلب المعتمد",
      cancellation_awaiting_approval: "طلب الإلغاء الخاص بك في انتظار موافقة المدير",
      adjust_allocation: "تعديل التخصيص",
      current_allocation: "الحالي",
      adjustment_amount: "مقدار التعديل",
      adjustment_hint: "موجب للزيادة، سالب للنقصان",
      reason: "السبب",
      adjustment_reason_placeholder: "سبب التعديل...",
      apply_adjustment: "تطبيق التعديل",
      allocation_adjusted: "تم تعديل التخصيص بنجاح",
      enter_valid_adjustment: "أدخل رقماً صحيحاً غير صفري",
      reason_required: "السبب مطلوب",
      change_history: "سجل التغييرات",
      admin_settings: "إعدادات النظام",
      admin_settings_desc: "تكوين إعدادات النظام",
      general: "عام",
      session_settings: "إعدادات الجلسة",
      session_timeout: "مهلة الجلسة",
      session_timeout_desc: "تسجيل خروج المستخدمين تلقائياً بعد فترة من عدم النشاط",
      minutes: "دقيقة",
      save_settings: "حفظ الإعدادات",
      settings_saved: "تم حفظ الإعدادات",
      settings: "الإعدادات",
      spo_viewer: "مشاهد الراعي",
      select_sponsor: "اختر الراعي",
      choose_sponsor: "اختر الراعي",
      confirm_delivery: "تأكيد التسليم",
      confirm_delivery_msg: "تأكيد تسليم هذا الطلب؟ لن يكون الإلغاء ممكناً بعد ذلك.",
      delivery_confirmed: "تم تأكيد التسليم بنجاح",
      delivered_confirmed_label: "تم التسليم",
      delivery_note_placeholder: "إضافة ملاحظات التسليم (اختياري)...",
      mark_as_delivered: "تعيين كمسلّم",
      pending_your_approval: "تم إنشاء هذا الطلب نيابة عنك. يرجى المراجعة والموافقة.",
      add_notes_before_approval: "أضف ملاحظاتك قبل الموافقة...",
      approve_and_submit: "الموافقة والتقديم",
      reject_request: "رفض",
      confirm_sponsor_approve: "الموافقة على هذا الطلب وتقديمه للمراجعة؟",
      confirm_sponsor_reject: "رفض هذا الطلب؟ سيتم إغلاقه.",
      request_approved_by_sponsor: "تم اعتماد الطلب وتقديمه",
      request_rejected_by_sponsor: "تم رفض الطلب",
      request_created_on_behalf: "تم إنشاء الطلب نيابة عن الراعي",
      pending_sponsor_approval: "في انتظار موافقة الراعي",
      sponsor_reports: "تقارير الرعاة",
      sponsor_reports_desc: "عرض التقارير المشتركة من مدير حسابك",
      usage_reports: "تقارير الاستخدام",
      reports_desc: "إدارة تقارير الرعاة وعرض الاستخدام",
      create_report: "إنشاء تقرير",
      round_number: "رقم الجولة",
      report_link: "رابط التقرير",
      report_title_placeholder: "مثال: تقرير ملخص الجولة 15",
      view_report: "عرض التقرير",
      report_created: "تم إنشاء التقرير",
      no_reports: "لا توجد تقارير",
      session_expired: "انتهت الجلسة. يرجى تسجيل الدخول مرة أخرى.",
      create_on_behalf: "إنشاء نيابة عن",
      sync_spl: "مزامنة الدوري",
      syncing: "جاري المزامنة...",
      matches_imported: "مباراة مستوردة",
      skipped: "موجودة مسبقاً",
      synced: "تمت المزامنة",
      approve_all: "الموافقة على الكل",
      reject_all: "رفض الكل",
      confirm_approve_all: "الموافقة على جميع الطلبات",
      confirm_reject_all: "رفض جميع الطلبات",
      approve_all_disclaimer: "سيتم الموافقة على جميع الطلبات المعلقة بالكميات المطلوبة كاملة. لا يمكن التراجع عن هذا الإجراء.",
      reject_all_disclaimer: "سيتم رفض جميع الطلبات المعلقة. لا يمكن التراجع عن هذا الإجراء.",
      send_decision: "إرسال القرار",
      decision_sent: "تم إرسال القرار بنجاح",
      all_items_approved: "تم تعيين جميع العناصر كمعتمدة",
      translations_label: "الترجمات",
      just_now: "الآن",
    }
  }
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('lang') || 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
